import api from './index';

export const fetchDashboardMetrics = () =>
  api.get('/dashboard-metrics').then(res => res.data);